export type ChannelType = "email" | "sms" | "slack" | "teams" | "webhook";

export const CHANNEL_TYPES: ChannelType[] = ["email", "sms", "teams", "webhook"];

export type SmsProvider = "twilio" | "aws_sns";
export type WebhookHttpMethod = "POST" | "PUT" | "PATCH";
export type WebhookAuthType = "none" | "bearer" | "basic";

export interface SecretField {
  is_set: boolean;
  value: string; // always "" or "********" on read
}

export interface EmailConfig {
  sendgrid_api_key: SecretField;
  from_address: string;
  from_name?: string;
  reply_to?: string;
}

export interface SmsConfig {
  provider: SmsProvider;
  api_key: string;
  auth_token: SecretField;
  from_number: string;
}

export interface SlackConfig {
  bot_token: SecretField;
  default_channel: string;
  signing_secret: SecretField;
  webhook_url: SecretField;
}

export interface TeamsConfig {
  webhook_url: SecretField;
  client_secret?: SecretField;
  default_channel?: string;
  app_id?: string;
  tenant_id?: string;
  bot_user_email?: string;
}

export interface WebhookConfig {
  endpoint_url: string;
  http_method: WebhookHttpMethod;
  headers: Record<string, string>;
  auth_type: WebhookAuthType;
  secret: SecretField;
  max_retries: number;
  backoff_seconds: number;
}

export type ChannelConfig =
  | EmailConfig
  | SmsConfig
  | SlackConfig
  | TeamsConfig
  | WebhookConfig;

export interface ChannelSettingResponse {
  channel_type: ChannelType;
  is_enabled: boolean;
  config: ChannelConfig;
  updated_at: string;
  updated_by: { id: number; email: string } | null;
}

export interface ChannelSettingUpdate {
  is_enabled: boolean;
  // Loose typing on write since secrets travel as either string or { clear: true } / "********"
  config: Record<string, unknown>;
}

export interface TestSendResult {
  success: boolean;
  latency_ms: number;
  provider_status?: string | null;
  provider_response?: string | null;
}
